module.exports = __webpack_public_path__ + "static/media/20201129_212937_595_IMG_1843.7802c8ee.jpg";